import { message } from "ant-design-vue";

/** 模型使用权限不足 */
export const MODEL_PERMISSION_DENIED_CODE = 90712;

/** 暂无使用权限 */
export const MODEL_PERMISSION_DENIED_TITLE = "暂无使用权限";

/** 提示内容 */
export const MODEL_PERMISSION_DENIED_CONTENT =
  "当前账号暂无该模型使用权限，请联系管理员调整。";

/**
 * 模型使用权限不足 toast 提示（HTTP 和 WebSocket 共用）
 * 不阻断用户操作，3 秒后自动消失
 */
export function showModelPermissionDeniedModal() {
  message.warning(MODEL_PERMISSION_DENIED_CONTENT, 3);
}
